import React from "react";
import { FieldRenderProps } from "react-final-form";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from "@material-ui/core";
import withFieldControl from "../FieldControl";
import FormControlError from "../FormControlError";
import { Container } from "./styles";

type DictionaryItem = {
  value: any;
  label: string;
};

type Props = {
  title?: string;
  required?: boolean;
  inline?: boolean;
  disabled?: boolean;
} & FieldRenderProps<any>;

class CheckboxGroupFieldControl extends React.Component<Props> {
  onChange = (items: DictionaryItem[] = []) => {
    const value = items.map(item => item.value);
    const event: any = { target: { value } };
    this.props.input.onChange(event);
  };

  get selected() {
    const { options, input } = this.props;
    const value = input?.value || [];

    return value.map((item: any) => {
      return options?.find(
        (findItem: DictionaryItem) => findItem.value === item,
      );
    });
  }

  onChangeCheckbox = (option: DictionaryItem) => () => {
    const { required } = this.props;
    let items = this.selected || [];

    const isSelected = items.some(
      (item: DictionaryItem) => item.value.id === option.value.id,
    );

    if (isSelected) {
      items = items.filter(
        (item: DictionaryItem) => item.value.id !== option.value.id,
      );
    } else {
      items.push(option);
    }

    if (!required || items.length > 0) {
      this.onChange(items);
    }
  };

  render() {
    const { options, inline, title, meta, disabled } = this.props;

    const error = (meta.touched || meta.dirty) && meta.error;

    return (
      <Container>
        <FormLabel>{title}</FormLabel>
        <FormGroup row={inline}>
          {options.map((option: DictionaryItem) => (
            <FormControlLabel
              key={option.value}
              labelPlacement="end"
              control={
                <Checkbox
                  checked={this.selected && this.selected.includes(option)}
                  onChange={this.onChangeCheckbox(option)}
                  name={option.label}
                  color="primary"
                  size="small"
                  disabled={disabled}
                />
              }
              label={option.label}
            />
          ))}
        </FormGroup>
        {error && <FormControlError error={error} />}
      </Container>
    );
  }
}

export default withFieldControl(CheckboxGroupFieldControl);
